<template>
  <div>
    <!-- <general-top-bar :title="$t('gestiune.reteta')"></general-top-bar> -->
    <div id="outer-container">
        <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
            <div class="card-content">
                <div class="clearfix row pad-lf-10 pad-rg-10">
                    <a
                      class="btn btn-fill btn-primary"
                      :class="{ active: isProducts }"
                      @click="openProducts"
                    >{{$t('gestiune.products')}}</a>
                    <a
                      class="btn btn-fill btn-primary"
                      :class="{ active: isClients }"
                      @click="openClients"
                    >{{$t('gestiune.clients')}}</a>
                    <a
                      class="btn btn-fill btn-primary"
                      :class="{ active: isSuppliers }"
                      @click="openSuppliers"
                    >{{$t('gestiune.suppliers')}}</a>
                </div>
            </div>
        </div>
    </div>
    <div v-if="isProducts">
      <NomenclatorProducts :grouped-locations="groupedLocations" :gestiuneOptions="gestiuneOptions"/>
    </div>
    <div v-if="isClients">
      <ManagementClients :grouped-locations="groupedLocations" :gestiuneOptions="gestiuneOptions"/>
    </div>
    <div v-if="isSuppliers">
      <ManagementSuppliers :grouped-locations="groupedLocations" :gestiuneOptions="gestiuneOptions"/>
    </div>
  </div>
</template>

<script>
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import NomenclatorProducts from 'src/components/Dashboard/Views/Management/Nomenclator/NomenclatorProducts.vue'
  import ManagementClients from 'src/components/Dashboard/Views/Management/Nomenclator/ManagementClients.vue'
  import ManagementSuppliers from 'src/components/Dashboard/Views/Management/Suppliers/ManagementSuppliers.vue'

  export default {
    components: {
      // GeneralTopBar,
      NomenclatorProducts,
      ManagementClients,
      ManagementSuppliers
    },
    data () {
      return {
        isProducts: true,
        isClients: false,
        isSuppliers: false
      }
    },
    props: {
      groupedLocations: {
        type: Array,
        required: true
      },
      gestiuneOptions: {
        type: Array,
        required: true
      }
    },
    created () {
    },
    methods: {
      openProducts () {
        this.isProducts = true
        this.isClients = false
        this.isSuppliers = false
      },
      openClients () {
        this.isProducts = false
        this.isClients = true
        this.isSuppliers = false
      },
      openSuppliers () {
        this.isProducts = false
        this.isClients = false
        this.isSuppliers = true
      }
    }
  }
</script>

<style scoped>
.form-check {
display: flex;
gap: 10px;
align-items: flex-start;
}
.action-buttons {
display: flex;
justify-content: space-between;
align-items: center; /* Aliniază butoanele pe axa verticală */
margin-bottom: 15px;
}

.left-buttons {
display: flex;
}

.left-buttons el-button {
margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}
.button-group {
display: flex; /* Folosește flexbox pentru alinierea orizontală */
justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Nomenclator/NomenclatorTabs.vue